import { Component, inject, OnInit, NgZone, OnDestroy, effect } from '@angular/core';
import { NgClass } from '@angular/common';
import { FooterComponent } from '@app/components/global/footer/footer.component';
import { HeaderComponent } from '@app/components/global/header/header.component';
import { LoadingComponent } from '@app/components/global/loading/loading.component';
import { CardComponent } from "@components/card/card.component";
import { Branches } from './services/fetch/branches';
import { Router, NavigationEnd, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { filter, fromEvent, merge, Subject, throttleTime, takeUntil, map, distinctUntilChanged } from 'rxjs';
import { Services } from './services/fetch/service';
import { Appointment } from './services/fetch/appointment';
import { Settings } from './services/fetch/settings';
import { TimeoutService } from './services/timeout/timeout.service';
import { ConfigurationsComponent } from './pages/configurations/configurations.component';
import { TvComponent } from './pages/tv/tv.component';


const ACTIVITY_THROTTLE_MS = 1000;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    NgClass,
    FooterComponent,
    HeaderComponent,
    LoadingComponent,
    TvComponent,
    CardComponent,
    ConfigurationsComponent
],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit, OnDestroy {

  protected fetchBranches = inject( Branches );
  protected fetchService = inject( Services );
  protected fetchSettings = inject( Settings );
  
  protected fetchAppointement = inject( Appointment );
  private timeoutService = inject( TimeoutService );
  private zone = inject( NgZone );

  branchView = false;
  showNavigation = false;

  resetLocation = false;
  tvQ = false;

  isLoading = true
  settings = {}

  manageAppointment:string|null = null;

  private destroy$ = new Subject<void>();
  private customEventHandler: ((event: Event) => void) | null = null;

  constructor(private router: Router, private route: ActivatedRoute) {
    this.stripTrackingParams();

    this.router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map(() => this.findDeepest(this.router.routerState.snapshot.root)?.data),
        distinctUntilChanged((prev, curr) => prev?.['showNav'] === curr?.['showNav']),
        takeUntil(this.destroy$)
      ).subscribe((data: any) => {
        if(this.fetchSettings.categorySetting() === ''){
          this.fetchSettings.categorySetting.set("KIOSK")
        }
        if (data['target'] == 'yourAppointment' && this.manageAppointment == null){
          this.manageAppointment = this.router.routerState.snapshot.root.firstChild?.params['id']!
          this.fetchAppointement.appointmentGUID.set(this.manageAppointment)
        }
        this.showNavigation = !!data?.['showNav']; 
      });
  }

  stripTrackingParams() {
    const url = new URL(window.location.href);
    const paramsToRemove = ['_ga', '_gl', '_gid', 'utm_source', 'utm_medium', 'utm_campaign'];

    let changed = false;
    paramsToRemove.forEach(param => {
      if (url.searchParams.has(param)) {
        url.searchParams.delete(param);
        changed = true;
      }
    });

    if (changed) {
      // Update the URL without reloading the page
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }
  }

  get getBranches() {
    return (this.manageAppointment === null) ? !(this.fetchBranches.branchesRessource.value() !== undefined && this.fetchService.servicesRessource.value() !== undefined) : this.fetchAppointement.manageEventResource.isLoading()
  }

  get getServices(){
    return this.fetchSettings.settingsRessource.isLoading() && this.fetchSettings.settings() !== null && this.fetchSettings.settings() !== undefined
  }

  ngOnInit(): void {

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        const selectedBranch = document.cookie
        if(event.urlAfterRedirects.includes('splash') && !event.urlAfterRedirects.includes('token')){
          if(!selectedBranch.includes('selectedBranch'))
            this.router.navigate(['configuration'])
          else {
            const match = selectedBranch.match(/selectedBranch=([^;]+)/)
            this.router.navigate(['splash'], { queryParams: { origin: 'kiosk', branch: match![1]}})
          }
        }
        this.branchView = event.urlAfterRedirects === '/branches-location';
        this.resetLocation = (event.url === '/configuration')
        this.tvQ = event.url.includes('tv')
      });

    this.setupActivityListener();
    
    const customEventHandler = (event: Event) => {
      const customEvent = event as CustomEvent;
      
      this.zone.run(() => {
        this.timeoutService.restartTimeoutTimer();
      });
    };
    
    document.addEventListener('afcu-restart-timeout', customEventHandler);
    
    this.customEventHandler = customEventHandler;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    
    if (this.customEventHandler) {
      document.removeEventListener('afcu-restart-timeout', this.customEventHandler);
      this.customEventHandler = null;
    }
    
  }

  private findDeepest(s: ActivatedRouteSnapshot | null): ActivatedRouteSnapshot | null {
    return s?.firstChild ? this.findDeepest(s.firstChild) : s;
  }

  private setupActivityListener(): void {
    
    this.zone.runOutsideAngular(() => {
      const activityEvents$ = merge(
        fromEvent(document, 'mousemove'),
        fromEvent(document, 'click'),
        fromEvent(document, 'mousedown'),
        fromEvent(document, 'keydown'),
        fromEvent(document, 'touchstart'),
        fromEvent(document, 'scroll')
      );
  
      activityEvents$.pipe(
        throttleTime(ACTIVITY_THROTTLE_MS, undefined, { leading: true, trailing: false }),
        takeUntil(this.destroy$)
      ).subscribe(() => {
  
        this.zone.run(() => {
          const isModalActive = this.timeoutService.isModalActive();
          if (!isModalActive) {
            this.timeoutService.restartTimeoutTimer();
          } else {
          }
        });
      });
    });
  }
}